import React from 'react';
import { connect } from 'react-redux';
import Loader from '../../components/Loader';
import { authenticate } from '../../shared/ducks/session';
import { LoginForm } from './components/LoginForm';

/**
 * Login Container
 */
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            credentials: {
                username: '',
                password: '',
            },
            errors: {},
        };
    }

    componentWillUpdate() {
        if (Object.keys(this.state.errors).length) {
            this.setState({ errors: {} });
        }
    }

    isAValidForm = () => {
        const { username, password } = this.state.credentials;

        let errors = {};

        if (username.length === 0) {
            errors.username = 'Username is required';
        } else if (password.length === 0) {
            errors.password = `Password is required`;
        }

        if (Object.keys(errors).length) {
            this.setState({ errors });
            return false;
        }

        return true;
    };

    handleChange = e => {
        const credentials = { ...this.state.credentials };
        credentials[e.target.name] = e.target.value;
        this.setState({ credentials });
    };

    submitForm = event => {
        event.preventDefault();

        if (this.isAValidForm()) {
            if (!Object.keys(this.state.errors).length) {
                this.props.onSubmit(
                    this.state.credentials.username,
                    this.state.credentials.password
                );
            }
        }
    };

    render() {
        const { isFetching: isFetchingConfig, environment } = this.props.config;
        const { isTAASFetching, isFetching, expired, noaccess } = this.props.session;
        const showLoader = !!(isFetchingConfig || isFetching);

        if (showLoader) {
            return <Loader />;
        }

        return (
            <LoginForm
                credentials={this.state.credentials}
                errors={this.state.errors}
                handleChange={this.handleChange}
                submitForm={this.submitForm}
                isTAASFetching={isTAASFetching}
                sessionExpired={expired}
                noAccess={noaccess}
                environment={environment}
            />
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    session: state.session,
    login: state.login,
});

const mapDispatchToProps = dispatch => ({
    onSubmit: (username, password) => dispatch(authenticate(username, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
